import { Modal, Tabs } from 'antd'
import { useParams, useNavigate } from 'react-router-dom'
import {
  GetCompetitionsByUserId,
  GetUserFollowersCreatorsList,
  GetUserFollowingCreatorsList,
  GetUsersDetailsById,
  GetVideosByUserId,
} from 'hooks'
import { useState } from 'react'
import { CommonVideosList } from 'page-components'
import styled from 'styled-components'
import { ArrowLeft, CaretRight, GenderFemale, GenderMale } from 'phosphor-react'
import { CompetitionDetail } from './compititonDetails'
import { LoaderBar, UserAvatarWithName } from 'components'
import { CommonUtility, DateFormat, DateUtility } from 'utility'
import { Images } from 'assets'

const BackIcon = styled(ArrowLeft)`
  cursor: pointer;
`
const HeaderWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`
const LoginDetail = styled.div`
  font-size: 14px;
  font-family: var(--font-secondary);
  font-weight: 500;
  color: #808080;

  span {
    font-weight: bold;
    color: #4c4c4c;
  }
`

const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

const Title = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: #1a1a1a;
`

const Breadcrumbs = styled.div`
  font-size: 14px;
`
const Link = styled.a`
  color: #84a1ff;
  text-decoration: none;
  font-weight: 500;

  span {
    color: #2454ff;
  }
`
const Container = styled.div`
  width: 100%;
  background: #fff;
`
const ProfileContainer = styled.div`
  font-family: var(--font-secondary);
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 20px;
`
const ProfileHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`
const ProfileImage = styled.img`
  width: 80px;
  height: 80px;
  border-radius: 50%;
`
const ProfileInfo = styled.div`
  flex: 1;
  margin-left: 16px;
`
const CreatorName = styled.h2`
  margin: 0;
  color: #1a1a1a;
  font-weight: 600;
  font-size: 20px;
`
const LastLogin = styled.p`
  font-size: 14px;
  color: #888;
  margin: 4px 0;
`
const Badge = styled.span`
  color: #808080;
  padding: 4px 16px;
  border: 1px solid #808080;
  border-radius: 20px;
  font-weight: 700;
  font-size: 12px;
`
const ProfileStats = styled.div`
  display: flex;
  gap: 30px;
`
const ProfileExtra = styled.div`
  display: flex;
  gap: 30px;
  text-align: center;
`
const StatItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  font-size: 16px;

  strong {
    font-size: 20px;
    font-family: var(--font-secondary);
    font-weight: 700;
    color: #4c4c4c;
  }

  span {
    color: #888;
    font-size: 14px;
  }
`
const InfoBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;

  font-size: 16px;

  strong {
    font-family: var(--font-secondary);
    font-weight: 700;
    color: #4c4c4c;
  }

  span {
    color: #888;
    font-size: 14px;
  }
`

export const CreatorsDetails = () => {
  const navigate = useNavigate()
  const { id } = useParams()
  // const { data: creator } = GetCreatorsList(id)
  const { data: CreatorsData, loading } = GetUsersDetailsById(id)
  const {
    data,
    loadMore,
    setData,
    hasMore,
    loading: videoLoading,
  } = GetVideosByUserId(id)
  const { data: Competitions } = GetCompetitionsByUserId(id)
  const [tab, setTab] = useState('1')
  const [isFollowerModalOpen, setFollowerModalOpen] = useState(false)
  const [isFollowingModalOpen, setFollowingModalOpen] = useState(false)

  const displayLoginId = () => {
    if (CreatorsData?.signup_method === "phone") {
      return CommonUtility.formatMobileNumber(CreatorsData?.loginIdPhone);
    }
    if (CreatorsData?.signup_method === "google.com") {
      return CreatorsData?.loginIdEmail;
    }
    return "-";
  };

  const items = [
    {
      key: '1',
      label: 'Videos',
      children: (
        <CommonVideosList
          showSearchBar={false}
          data={data}
          loading={videoLoading}
          loadMore={loadMore}
          setData={setData}
          hasMore={hasMore}
        />
      ),
    },
    {
      key: '2',
      label: 'Competition',
      children: <CompetitionDetail data={Competitions} />,
    },
  ]
  return (
    <Container>
      <HeaderWrapper className="p-4">
        <LeftSection>
          {/* When BackIcon is clicked, navigate to the Creators List page */}
          <BackIcon
            size={24}
            onClick={() => navigate('/app/manage-creators')}
          />
        </LeftSection>

        <Breadcrumbs>
          <Title>Creator Profile</Title>
          <Link href="/app/manage-creators">Manage Creators</Link>
          <CaretRight size={12} color="#84a1ff" />
          <Link href="/app/manage-creators/trapster-x">
            <span>{CreatorsData?.name}</span>
          </Link>
        </Breadcrumbs>
      </HeaderWrapper>
      {loading ? (
        <LoaderBar />
      ) : (
        <ProfileContainer className="px-5">
          <ProfileHeader>
            <ProfileImage
              src={
                CreatorsData?.photo_url ||
                (CreatorsData?.gender === 'female'
                  ? Images.FemaleUser
                  : Images.MaleUser)
              }
              alt={CreatorsData?.name}
            />

            <ProfileInfo>
              <LastLogin className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-start gap-2">
                  {CreatorsData?.gender === 'female' ? (
                    <GenderFemale className="mt-1" size={24} color="#1a1a1a" />
                  ) : (
                    <GenderMale className="mt-1" size={24} color="#1a1a1a" />
                  )}
                  <div className="d-flex flex-column">
                    <div className="d-flex gap-4 align-items-center">
                      <CreatorName>{CreatorsData?.name}</CreatorName>
                      <Badge>{CreatorsData?.genre}</Badge>
                    </div>
                    <LoginDetail>
                      Last Login: {' '}
                      {CommonUtility.getTimeAgo(CreatorsData?.last_login_at)}
                    </LoginDetail>
                  </div>
                </div>
              </LastLogin>
              <div className="d-flex justify-content-between mt-2 align-items-center">
                <ProfileStats>
                  <StatItem
                    onClick={() => setFollowerModalOpen(true)}
                    style={{ cursor: 'pointer' }}
                  >
                    <strong>{CreatorsData?.followers_count || '0'}</strong>
                    <span>Followers</span>
                  </StatItem>
                  <StatItem
                    onClick={() => setFollowingModalOpen(true)}
                    style={{ cursor: 'pointer' }}
                  >
                    <strong>{CreatorsData?.following_count || '0'}</strong>
                    <span>Following</span>
                  </StatItem>
                  <StatItem>
                    <strong>{CreatorsData?.video_count || '0'}</strong>
                    <span>Videos</span>
                  </StatItem>
                </ProfileStats>
                <ProfileExtra>
                  <InfoBlock>
                    <strong>
                      {displayLoginId()}
                    </strong>
                    <span>Login Id</span>
                  </InfoBlock>
                  <InfoBlock>
                    <strong>{CreatorsData?.birth_date || '-'}</strong>
                    <span>Birthdate</span>
                  </InfoBlock>
                  <InfoBlock>
                    <strong>{DateUtility.formatDate(CreatorsData?.createdAt,DateFormat.DDMMYYYY_) || '-'}</strong>
                    <span>Member Since</span>
                  </InfoBlock>
                </ProfileExtra>
              </div>
              {/* <CustomButton> */}{' '}
              {/* <Prohibit size={20} color="#e22400" /> */}
              {/* Block Creator */}
              {/* </CustomButton> */}
              <p
                style={{
                  marginTop: '30px',
                  color: '#4C4C4C',
                  fontWeight: 500,
                  fontSize: '13px',
                  lineHeight: '20px',
                }}
              >
                {CreatorsData?.bio}
              </p>
            </ProfileInfo>
          </ProfileHeader>
        </ProfileContainer>
      )}
      <FollowersModal
        open={isFollowerModalOpen}
        onClose={() => setFollowerModalOpen(false)}
        id={id}
      />
      <FollowingModal
        open={isFollowingModalOpen}
        onClose={() => setFollowingModalOpen(false)}
        id={id}
      />
      <div className="px-5">
        <Tabs
          activeKey={tab}
          onChange={key => setTab(key)}
          items={items}
          className="custom-tabs"
          centered
        />
      </div>
    </Container>
  )
}

const StyledModal = styled(Modal)`
          .ant-modal-content {
            border - radius: 12px;
          padding: 20px;
          background: #ffffff;
          box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  }

          .ant-modal-header {
            border - bottom: none;
          text-align: center;
          font-weight: bold;
  }

          .ant-modal-close {
            top: 12px;
          right: 12px;
  }
          `

const FollowersList = styled.div`
  max-height: 300px;
  overflow-y: auto;
  padding-right: 5px;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #bbb;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #999;
  }
`

// Each Follower Item
const FollowerItem = styled.div`
  display: flex;
  align-items: center;
  padding: 5px;
  background: #f9f9f9;
  border-radius: 8px;
  margin-bottom: 8px;
  transition: background 0.2s ease-in-out;

  &:hover {
    background: #eaeaea;
  }
`
export const FollowingModal = ({ open, onClose, id }) => {
  const { data: followersData } = GetUserFollowingCreatorsList(id)

  return (
    <StyledModal
      title="Following List"
      open={open}
      onOk={onClose}
      onCancel={onClose}
      footer={null} // Remove if you want buttons
    >
      <FollowersList>
        {followersData?.map(ele => (
          <FollowerItem key={ele?._id}>
            <UserAvatarWithName
              onClose={onClose}
              title={ele?.name}
              url={ele?.image}
            />
          </FollowerItem>
        ))}
      </FollowersList>
    </StyledModal>
  )
}

export const FollowersModal = ({ open, onClose, id }) => {
  const { data: followersData } = GetUserFollowersCreatorsList(id)

  return (
    <StyledModal
      title="Followers List"
      open={open}
      onOk={onClose}
      onCancel={onClose}
      footer={null} // Remove if you want buttons
    >
      <FollowersList>
        {followersData?.map(ele => (
          <FollowerItem key={ele?._id}>
            <UserAvatarWithName
              onClose={onClose}
              title={ele?.name}
              url={ele?.image}
            />
          </FollowerItem>
        ))}
      </FollowersList>
    </StyledModal>
  )
}
